import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const FilterLevelFourSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocation.availableFilters.level_4);
  const selectedOptions = useSelector((state) => state.multiLocation.selectedLevelFourth);

  const title = useSelector((state) => state.multiLocation.availableFilters.filter_titles[3]);

  const fourthLevelFiltersLoading = useSelector(
    (state) => state.multiLocation.fourthLevelFiltersLoading
  );

  return fourthLevelFiltersLoading ? (
    <LoadingAnimation uiLoader />
  ) : (
    <>
      <p>{title}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOptions}
        placeholder="Please Select"
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        onSelectChange={(data) => dispatch(actionCreators.updateSelectedFourthLevelFilters(data))}
      />
    </>
  );
};

export default FilterLevelFourSelect;
